(function () {
  // If someone arrives via a link with ?variant=..., respect it
  const hasVariantInUrl = new URLSearchParams(location.search).has('variant');
  const chosen = new Set(); // indexes of option groups the visitor picked
  let seeded = false; // true once URL-provided options have been marked as picked
  const PLACEHOLDER_TEXT = 'Choose an option';
  const HINT_PREFIX = 'Select';
  const HINT_SUFFIX = 'above to Add to cart';
    const SHOW_HINT = false; // set to true to show the info line under the dropdowns again
  const STICKY_MESSAGE_MULTI = 'Select options above to add to cart';
  const STICKY_MESSAGE_PREFIX = 'Select';
  const STICKY_MESSAGE_SUFFIX = 'above to add to cart';
  const BUTTON_SELECTOR = 'button[name="add"], [name="add"]';
  // Button text that means the variant can't be bought
  const UNAVAILABLE_PATTERN = /unavailable|sold\s*out/i;

  // Screens up to this width count as mobile
  const MOBILE_QUERY = '(max-width: 749px)';

  // Sticky add to cart bar (selectors cover the common naming patterns)
  const BAR_SELECTOR =
    'sticky-add-to-cart, [class*="sticky-add-to-cart"], ' +
    '[class*="sticky_add_to_cart"], [class*="sticky-atc"]';
  const STICKY_SELECTOR = BAR_SELECTOR.split(', ').map((s) => s + ' button').join(', ');
  // A short text that looks like a price, e.g. $18.99
  const PRICE_PATTERN = /[$€£¥]\s*\d|\d\s*[$€£¥]|\d[.,]\d{2}/;
  // A text that looks like a variant name, e.g. "6-Loop / XS - (...)"
  const VARIANT_PATTERN = /\s\/\s/;
  const observedBars = new WeakSet();

  // "From" label before the price until a variant is picked
  const FROM_TEXT = 'From';
  let pricesVary = window.fvsPricesVary === true;

  (function loadPrices() {
    const m = location.pathname.match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'products/' + m[1] + '.js')
      .then((r) => r.json())
      .then((p) => {
        const prices = p.variants.map((v) => v.price);
        pricesVary = Math.min.apply(null, prices) !== Math.max.apply(null, prices);
        enforce();
      })
      .catch(() => {});
  })();

  function updateFromLabel(picker, ready) {
    const show = pricesVary && !ready;
    let label = document.querySelector('.fvs-from');

    if (!show) {
      if (label) label.remove();
      return;
    }
    if (label) return;

    // search the product section first, then the whole page
    const scopes = [picker.closest('.shopify-section'), document].filter(Boolean);
    let priceEl = null;
    for (const scope of scopes) {
      priceEl = Array.from(scope.querySelectorAll('*')).find((el) => {
        if (el.children.length) return false;
        if (el.closest('button, .fvs-hint, .fvs-from, del, s, variant-picker, [class*="compare"]')) return false;
        if (el.closest(BAR_SELECTOR)) return false; // skip the sticky add to cart bar
        // must come before the picker in the page
        if (!(el.compareDocumentPosition(picker) & Node.DOCUMENT_POSITION_FOLLOWING)) return false;
        const text = el.textContent.trim();
        return text.length < 20 && PRICE_PATTERN.test(text);
      });
      if (priceEl) break;
    }
    if (!priceEl) {
      console.log('[fvs] price element not found');
      return;
    }

    label = document.createElement('span');
    label.className = 'fvs-from';
    label.textContent = FROM_TEXT;
    const labelStyles = {
      display: 'inline',
      'margin-right': '0.35em',
      color: '#6b6b6b',
      'font-size': '0.75em',
      'font-weight': 'normal',
      'text-transform': 'none'
    };
    Object.keys(labelStyles).forEach((p) => label.style.setProperty(p, labelStyles[p], 'important'));
    priceEl.insertAdjacentElement('beforebegin', label);
  }

  // Outermost sticky bar elements only
  function getStickyBars() {
    return Array.from(document.querySelectorAll(BAR_SELECTOR)).filter(
      (el) => !(el.parentElement && el.parentElement.closest(BAR_SELECTOR))
    );
  }

  // Sticky bar content while options are missing:
  //  - desktop: title and price hidden, variant name replaced by an info message
  //  - mobile: the whole bar is hidden
  function toggleStickyInfo(bar, ready) {
    const isMobile = window.matchMedia(MOBILE_QUERY).matches;

    // Option values from the product's dropdowns/radios, e.g. "4.6x6.5ft (140x200cm)"
    const optionTexts = Array.from(
      document.querySelectorAll(
        'variant-picker select option:not([data-placeholder]), variant-picker input[type="radio"]'
      )
    )
      .map((o) => (o.tagName === 'OPTION' ? o.textContent : o.value).replace(/\s+/g, ' ').trim().toLowerCase())
      .filter((t) => t.length >= 3);

    function looksLikeVariant(text) {
      if (VARIANT_PATTERN.test(text)) return true; // "6-Loop / XS"
      const t = text.replace(/\s+/g, ' ').trim().toLowerCase();
      if (t.length < 3) return false;
      // single-option products: the text matches an option value
      return optionTexts.some((o) => o === t || o.startsWith(t) || t.startsWith(o));
    }

    // Find the variant name, price and title texts inside the bar
    const priceEls = [];
    const variantEls = [];
    const titleEls = [];
    Array.from(bar.querySelectorAll('*')).forEach((el) => {
      if (el.children.length || el.closest('button') || el.closest('.fvs-sticky-msg')) return;
      const text = el.textContent.trim();
      if (!text) return;
      if (looksLikeVariant(text)) variantEls.push(el);
      else if (text.length < 20 && PRICE_PATTERN.test(text)) priceEls.push(el);
      else titleEls.push(el);
    });

    // Fallback: if no variant line was recognized, treat the second text line as the variant
    if (!variantEls.length && titleEls.length > 1) {
      variantEls.push(titleEls.splice(1, 1)[0]);
    }

    // Mobile: hide the entire bar until everything is picked
    if (!ready && isMobile) {
      bar.style.setProperty('display', 'none', 'important');
      bar.dataset.fvsBarHidden = 'true';
    } else if (bar.dataset.fvsBarHidden) {
      bar.style.removeProperty('display');
      delete bar.dataset.fvsBarHidden;
    }

    // Price: hidden (keeps its space) until ready
    priceEls.forEach((el) => {
      if (!ready) {
        el.style.setProperty('visibility', 'hidden', 'important');
        el.dataset.fvsHidden = 'true';
      } else if (el.dataset.fvsHidden) {
        el.style.removeProperty('visibility');
        delete el.dataset.fvsHidden;
      }
    });

    const showMsg = !ready && !isMobile && variantEls.length > 0;

    // Desktop: hide the product title while the message is showing
    titleEls.forEach((el) => {
      if (showMsg) {
        el.style.setProperty('display', 'none', 'important');
        el.dataset.fvsTitle = 'true';
      } else if (el.dataset.fvsTitle) {
        el.style.removeProperty('display');
        delete el.dataset.fvsTitle;
      }
    });

    // Desktop: swap the variant name for the info message
    variantEls.forEach((el) => {
      if (showMsg) {
        el.style.setProperty('display', 'none', 'important');
        el.dataset.fvsDisplay = 'true';
      } else if (el.dataset.fvsDisplay) {
        el.style.removeProperty('display');
        delete el.dataset.fvsDisplay;
      }
    });

    // One dropdown: use its name (e.g. "Size"). Two or more: "options"
    const firstPicker = document.querySelector('variant-picker');
    const pickerGroups = firstPicker ? getGroups(firstPicker) : [];
    let msgText = STICKY_MESSAGE_MULTI;
    if (pickerGroups.length === 1) {
      // drop marketing text like "(Bigger Pack, Bigger Savings)" from the name
      const optionName = getOptionName(pickerGroups[0])
        .replace(/\s*\(?\s*bigger\s+pack\s*,?\s*bigger\s+savings\s*\)?/gi, '')
        .trim();
      msgText = STICKY_MESSAGE_PREFIX + ' ' + (optionName || 'option') + ' ' + STICKY_MESSAGE_SUFFIX;
    }

    let msg = bar.querySelector('.fvs-sticky-msg');
    if (showMsg) {
      if (!msg) {
        msg = document.createElement('div');
        msg.className = 'fvs-sticky-msg';
        msg.innerHTML = INFO_ICON + '<span></span>';
        const msgStyles = {
          display: 'flex',
          'align-items': 'center',
          gap: '4px',
          color: '#6b6b6b',
          'font-size': '0.875rem',
          'line-height': '1.4',
          margin: '0',
          padding: '0'
        };
        Object.keys(msgStyles).forEach((p) => msg.style.setProperty(p, msgStyles[p], 'important'));
        variantEls[0].insertAdjacentElement('afterend', msg);
      }
      // only touch the DOM when the text changed (avoids observer loops)
      const span = msg.querySelector('span');
      if (span.textContent !== msgText) span.textContent = msgText;
    } else if (msg) {
      msg.remove();
    }
  }

  function updateSticky(ready, unavailable) {
    document.querySelectorAll(STICKY_SELECTOR).forEach((btn) => {
      // only touch the add button, not other buttons inside the bar
      const isAddButton =
        btn.matches('[name="add"]') || /add to cart|unavailable|sold\s*out/i.test(btn.textContent);
      if (isAddButton) updateButton(btn, !ready || unavailable);
    });

    getStickyBars().forEach((bar) => {
      // watch the bar too, since it sits outside the product section
      if (!observedBars.has(bar)) {
        observedBars.add(bar);
        observer.observe(bar, { childList: true, subtree: true, characterData: true });
      }
      toggleStickyInfo(bar, ready);
    });
  }

  // Safety net: block clicks on the sticky button until options are chosen
  document.addEventListener(
    'click',
    (e) => {
      const btn = e.target.closest && e.target.closest(STICKY_SELECTOR);
      if (btn && btn.dataset.fvsDisabled) {
        e.preventDefault();
        e.stopImmediatePropagation();
      }
    },
    true
  );

  // Floating card look for dropdowns
  const ACCENT = '#e8828a';                 // border of an unselected dropdown
  const ACCENT_SHADOW = 'rgba(232, 130, 138, 0.45)';
  const ACCENT_LABEL = '#c0525c';           // small label color while unselected
  const DONE_BORDER = '#d9d9d9';            // border once picked
  const DONE_LABEL = '#777777';             // small label color once picked
  const FIELD_HEIGHT = '56px';
  const DESKTOP_INSET = 8; // px trimmed from each side of the dropdowns on desktop

  // Tinted look for radio groups (dropdowns use the floating card look)
  const UNSET_BG = '#fcf7f7ff';
  const UNSET_BORDER = '#ecb8b8ff';

  // Hint spacing. Negative values cancel extra space the theme adds.
  // Desktop and mobile are separate so you can tune them independently.
  const SPACING = {
    desktop: { top: '-10px', bottom: '2px', paddingLeft: '8px' },
    mobile:  { top: '-14px', bottom: '0px', paddingLeft: '2px' }
  };

  // Info icon shown in front of the hint text (uses the text color)
  const INFO_ICON =
    '<svg viewBox="1 1 22 22" width="13" height="13" fill="none" stroke="currentColor" ' +
    'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" ' +
    'focusable="false" style="flex:0 0 auto;display:block;width:13px;height:1.4em">' +
    '<circle cx="12" cy="12" r="10"></circle>' +
    '<line x1="12" y1="16" x2="12" y2="12"></line>' +
    '<line x1="12" y1="8" x2="12.01" y2="8"></line>' +
    '</svg>';

  function getGroups(picker) {
    // radio groups live in fieldsets; dropdown style uses <select>
    const fieldsets = Array.from(picker.querySelectorAll('fieldset'));
    const selects = Array.from(picker.querySelectorAll('select')).filter(
      (s) => !s.closest('fieldset')
    );
    return [...fieldsets, ...selects];
  }

  // Work out the option name (Size, Color...) for a dropdown or radio group
  function getOptionName(group) {
    let name = '';

    if (group.tagName === 'FIELDSET') {
      const legend = group.querySelector('legend');
      name = legend ? legend.textContent : '';
    } else {
      // 1. a <label for="select-id">
      if (group.id) {
        const label = document.querySelector('label[for="' + CSS.escape(group.id) + '"]');
        if (label) name = label.textContent;
      }
      // 2. a wrapping <label>
      if (!name) {
        const wrap = group.closest('label');
        if (wrap) name = wrap.textContent.replace(group.textContent, '');
      }
      // 3. aria-label
      if (!name) name = group.getAttribute('aria-label') || '';
      // 4. name attribute like options[Size]
      if (!name && group.name) {
        const m = group.name.match(/\[(.+)\]/);
        name = m ? m[1] : group.name;
      }
    }

    return name.replace(/[:\s]+$/, '').replace(/\s+/g, ' ').trim();
  }

  function clearGroup(group) {
    if (group.tagName === 'SELECT') {
      if (!group.querySelector('option[data-placeholder]')) {
        const opt = document.createElement('option');
        opt.value = '';
        opt.textContent = PLACEHOLDER_TEXT;
        opt.disabled = true;
        opt.dataset.placeholder = 'true';
        group.insertBefore(opt, group.firstChild);
      }
      group.value = '';
    } else {
      group.querySelectorAll('input[type="radio"]').forEach((r) => (r.checked = false));
    }
  }

      // Let the glow spill outside the dropdown's wrappers (themes often clip it)
  function unclip(group) {
    let el = group.parentElement;
    while (el && el !== document.body) {
      const cs = getComputedStyle(el);
      if (cs.overflow !== 'visible' || cs.overflowX !== 'visible') {
        el.style.setProperty('overflow', 'visible', 'important');
      }
      if (el.classList.contains('shopify-section')) break;
      el = el.parentElement;
    }
  }

  // Desktop only: make the dropdowns slightly narrower, centered
  function narrow(group) {
    const wrap = group.parentElement;
    if (!wrap) return;
    if (window.matchMedia(MOBILE_QUERY).matches) {
      wrap.style.removeProperty('width');
      wrap.style.removeProperty('margin-left');
      wrap.style.removeProperty('margin-right');
    } else {
      wrap.style.setProperty('width', 'calc(100% - ' + DESKTOP_INSET * 2 + 'px)', 'important');
      wrap.style.setProperty('margin-left', DESKTOP_INSET + 'px', 'important');
      wrap.style.setProperty('margin-right', DESKTOP_INSET + 'px', 'important');
    }
  }

    // Desktop only: line up the title row (e.g. "Chain net size" + finder button) with the boxes
  function alignTitle(group) {
    const first = getGroups(group.closest('variant-picker') || document)[0] || group;
    let el = first;
    let row = null;
    for (let i = 0; i < 6 && el && el !== document.body && !row; i++, el = el.parentElement) {
      const prev = el.previousElementSibling;
      if (!prev) continue;
      if (prev.textContent.trim() && !prev.querySelector('select') && !prev.classList.contains('fvs-hint')) {
        row = prev;
      }
      break;
    }
    if (!row) return;

    if (window.matchMedia(MOBILE_QUERY).matches) {
      row.style.removeProperty('padding-left');
      row.style.removeProperty('padding-right');
      row.style.removeProperty('box-sizing');
    } else {
      row.style.setProperty('box-sizing', 'border-box', 'important');
      row.style.setProperty('padding-left', DESKTOP_INSET + 'px', 'important');
      row.style.setProperty('padding-right', DESKTOP_INSET + 'px', 'important');
    }
  }

  // Floating card look while unselected and after; tint for radio groups
  function markGroup(group, isChosen) {
    if (group.tagName !== 'SELECT') {
      if (isChosen) {
        group.style.removeProperty('background-color');
        group.style.removeProperty('border');
        group.style.removeProperty('transition');
      } else {
        group.style.setProperty('background-color', UNSET_BG, 'important');
        group.style.setProperty('border', '1px solid ' + UNSET_BORDER, 'important');
        group.style.setProperty('transition', 'background-color 0.25s ease, border-color 0.25s ease', 'important');
      }
      return;
    }

    const set = (prop, value) => group.style.setProperty(prop, value, 'important');
    set('box-sizing', 'border-box');
    set('height', FIELD_HEIGHT);
    set('min-height', FIELD_HEIGHT);
    set('padding-top', '23px');
    set('padding-bottom', '4px');
    set('background-color', '#ffffff');
    set('border-radius', '8px');
    set('transition', 'border-color 0.25s ease, box-shadow 0.25s ease');

        unclip(group);
        narrow(group);
        alignTitle(group);

    if (isChosen) {
      set('border', '1px solid ' + DONE_BORDER);
      set('box-shadow', '0 2px 6px rgba(0, 0, 0, 0.08)');
    } else {
      set('border', '1.5px solid ' + ACCENT);
      set('box-shadow', '0 0 0 2px rgba(232, 130, 138, 0.18), 0 3px 13px ' + ACCENT_SHADOW);
    }

    // Clear any option colors set by earlier versions
    group.querySelectorAll('option').forEach((opt) => opt.style.removeProperty('color'));
  }

  // Small option name shown inside the top-left of each dropdown
  function updateFloatLabel(group, isChosen) {
    if (group.tagName !== 'SELECT') return;
    const parent = group.parentElement;
    if (!parent) return;

    // the label is positioned relative to the dropdown's wrapper
    if (getComputedStyle(parent).position === 'static') {
      parent.style.position = 'relative';
    }

    const key = group.id || group.name || '';
    let label = Array.from(parent.children).find(
      (el) => el.classList.contains('fvs-float-label') && el.dataset.fvsFor === key
    );
    if (!label) {
      label = document.createElement('span');
      label.className = 'fvs-float-label';
      label.dataset.fvsFor = key;
      label.setAttribute('aria-hidden', 'true'); // the dropdown already has its own accessible name
      group.insertAdjacentElement('afterend', label);
    }

    // only touch the DOM when the text changed (avoids observer loops)
    const text = getOptionName(group);
    if (label.textContent !== text) label.textContent = text;

    const cs = getComputedStyle(group);
    const left =
      group.offsetLeft + (parseFloat(cs.borderLeftWidth) || 0) + (parseFloat(cs.paddingLeft) || 0);
    const styles = {
      position: 'absolute',
      left: left + 'px',
      top: group.offsetTop + 7 + 'px',
      'max-width': Math.max(group.offsetWidth - left - 44, 60) + 'px',
      'font-size': '12px',
      'line-height': '1.2',
      'letter-spacing': '0.01em',
      'font-weight': 'normal',
      'text-transform': 'none',
      'white-space': 'nowrap',
      overflow: 'hidden',
      'text-overflow': 'ellipsis',
      'pointer-events': 'none',
      'z-index': '1',
      margin: '0',
      padding: '0',
      color: isChosen ? DONE_LABEL : ACCENT_LABEL,
      transition: 'color 0.25s ease'
    };
    Object.keys(styles).forEach((p) => label.style.setProperty(p, styles[p], 'important'));
  }

  function updateButton(btn, shouldDisable) {
    if (shouldDisable) {
      // only add what the theme hasn't already added, and remember it
      if (!btn.disabled) {
        btn.disabled = true;
        btn.dataset.fvsDisabled = 'true';
      }
      if (btn.getAttribute('aria-disabled') !== 'true') {
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.fvsAria = 'true';
      }
    } else {
      // only remove what WE added; leave the theme's own state alone
      if (btn.dataset.fvsDisabled) {
        btn.disabled = false;
        delete btn.dataset.fvsDisabled;
      }
      if (btn.dataset.fvsAria) {
        btn.removeAttribute('aria-disabled');
        delete btn.dataset.fvsAria;
      }
    }
  }

  // "Size", "Size and Color", "Size, Color and Material"
  function joinNames(names) {
    if (names.length <= 1) return names.join('');
    return names.slice(0, -1).join(', ') + ' and ' + names[names.length - 1];
  }

  // Small info row under the variant selectors
  function updateHint(picker, groups, ready) {
    if (!SHOW_HINT) {
      const old = picker.parentNode.querySelector('.fvs-hint');
      if (old) old.remove();
      return;
    }
    let hint = picker.parentNode.querySelector('.fvs-hint');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'fvs-hint';
      hint.setAttribute('role', 'status');
      hint.setAttribute('aria-live', 'polite');
      hint.innerHTML = INFO_ICON + '<span class="fvs-hint-text"></span>';
      picker.insertAdjacentElement('afterend', hint);
    }
    const textEl = hint.querySelector('.fvs-hint-text');

    const sp = window.matchMedia(MOBILE_QUERY).matches ? SPACING.mobile : SPACING.desktop;
    const styles = {
      display: ready ? 'none' : 'flex',
      'align-items': 'flex-start',
      'justify-content': 'flex-start',
      gap: '4px',
      width: '100%',
      'box-sizing': 'border-box',
      'text-align': 'left',
      color: '#6b6b6b',
      border: 'none',
      background: 'transparent',
      margin: sp.top + ' 0 ' + sp.bottom,
      padding: '0 0 0 ' + sp.paddingLeft,
      'font-size': '0.75rem',
      'line-height': '1.4',
      'letter-spacing': '0.01em'
    };
    Object.keys(styles).forEach((prop) => hint.style.setProperty(prop, styles[prop], 'important'));

    textEl.style.setProperty('text-align', 'left', 'important');
    textEl.style.setProperty('flex', '1 1 auto', 'important');

    const missing = groups
      .map((g, i) => (chosen.has(i) ? null : getOptionName(g)))
      .filter((n) => n !== null);

    // Remove marketing text like "(Bigger Pack, Bigger Savings)" from the hint
    const names = missing
      .filter(Boolean)
      .map((n) => n.replace(/\s*\(?\s*bigger\s+pack\s*,?\s*bigger\s+savings\s*\)?/gi, '').trim())
      .filter(Boolean);

    const text = ready
      ? ''
      : names.length
        ? HINT_PREFIX + ' ' + joinNames(names) + ' ' + HINT_SUFFIX
        : HINT_PREFIX + ' your options ' + HINT_SUFFIX;

    // only touch the DOM when something changed (avoids observer loops)
    if (textEl.textContent !== text) textEl.textContent = text;
    hint.style.setProperty('opacity', ready ? '0' : '1', 'important');
  }

  function enforce() {
        // Variant came from the URL (e.g. after a reload): treat every option as already picked
    if (hasVariantInUrl && !seeded) {
      document.querySelectorAll('variant-picker').forEach((picker) => {
        const groups = getGroups(picker);
        groups.forEach((_, i) => chosen.add(i));
        if (groups.length) seeded = true;
      });
    }

    document.querySelectorAll('variant-picker').forEach((picker) => {
      const groups = getGroups(picker);
      if (!groups.length) return;

      groups.forEach((group, i) => {
        if (!chosen.has(i)) clearGroup(group);
        markGroup(group, chosen.has(i));
        updateFloatLabel(group, chosen.has(i));
      });

      const ready = groups.every((_, i) => chosen.has(i));
      const scope = picker.closest('.shopify-section') || document;

      updateHint(picker, groups, ready);
      updateFromLabel(picker, ready);

      scope.querySelectorAll(BUTTON_SELECTOR).forEach((btn) => {
        const unavailable = ready && UNAVAILABLE_PATTERN.test(btn.textContent);
        updateButton(btn, !ready || unavailable);
      });

      // hide Shop Pay / dynamic checkout buttons until ready and available
      const anyUnavailable = Array.from(scope.querySelectorAll(BUTTON_SELECTOR)).some(
        (btn) => UNAVAILABLE_PATTERN.test(btn.textContent)
      );
      scope.querySelectorAll('.shopify-payment-button').forEach((el) => {
        el.style.display = ready && !anyUnavailable ? '' : 'none';
      });

      // keep the sticky add to cart bar in sync
      updateSticky(ready, anyUnavailable);
    });
  }

  // Record what the visitor actually picks
  document.addEventListener('change', (e) => {
    const picker = e.target.closest && e.target.closest('variant-picker');
    if (!picker) return;
    const idx = getGroups(picker).findIndex((g) => g === e.target || g.contains(e.target));
    if (idx > -1) chosen.add(idx);
    // wait for the theme's re-render to finish, then re-apply
    setTimeout(enforce, 50);
  });

  // Re-apply whenever the theme re-renders the product section or sticky bar
  let raf;
  const observer = new MutationObserver(() => {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(enforce);
  });

    // Observe each picker's section for theme re-renders
  function observePickers() {
    document.querySelectorAll('variant-picker').forEach((picker) => {
      if (picker.dataset.fvsObserved) return;
      picker.dataset.fvsObserved = 'true';
      const section = picker.closest('.shopify-section') || document.body;
      observer.observe(section, { childList: true, subtree: true, characterData: true });
    });
  }

  function init() {
    enforce();
    observePickers();
    document.documentElement.classList.add('fvs-ready');
    // switch between desktop and mobile behavior when the screen size changes
    window.matchMedia(MOBILE_QUERY).addEventListener('change', enforce);
  }

  if (document.readyState === 'loading') {
    // Run as soon as the picker is parsed, before the browser paints it
    const early = new MutationObserver(() => {
      if (!document.querySelector('variant-picker')) return;
      enforce();
      observePickers();
    });
    early.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', () => {
      early.disconnect();
      init();
    });
  } else {
    init();
  }
})();